export const TITLE = 'TITLE'


export function title(title) {
    return {
        type: TITLE,
        payLoad: title
    }
}
